<script lang="ts">
    import { round } from "@/Util/utils";
    import type {RaceAchievability} from "../../modules/ProgramAchievability"
    type $$Props = RaceAchievability["difficulty"] & {
        difficulty_target: number,
        ignore_difficulty: boolean
    }
    export let status: $$Props["status"]
    export let difficulty_achievable: $$Props["difficulty_achievable"]
    export let difficulty_target: $$Props["difficulty_target"]
    export let ignore_difficulty: $$Props["ignore_difficulty"]
</script>
<div>
    <div class="text-sm text-slate-500">
        {#if ignore_difficulty}
        Difficulty is unrestricted and is not factored into estimates.
        {:else if status === "fine"}
        The estimated difficulty score for this race is <span class="font-medium">{round(difficulty_achievable)}.</span>
        {:else}
        The estimated difficulty score for this race is <span class="font-medium">{round(difficulty_achievable)}</span> and is above your target <span class="font-medium">{round(difficulty_target)}</span>. You may find it challenging to handle parts of this race.
        {/if}
    </div>
</div>